import { Component, Story, Knobs } from './DocTypes';

const TextFieldStoryKnobs: Knobs = {
  label: {
    default: 'Name',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: 'Rodney Peters',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  showIfBlank: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  dataType: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'string', 'email', 'phonenumber'],
    delimiter: '\n  ',
  },
};
const TextFieldStory: Story = {
  title: 'Text',
  description: 'Text based fields',
  coreComponent: {
    html: `<tag-field{{...knobs}}>
</tag-field>`,
    knobs: TextFieldStoryKnobs,
  },
  reactWrapper: { jsx: `<TagField{{...knobs}} />`, knobs: TextFieldStoryKnobs },
};
const NumberFieldStoryKnobs: Knobs = {
  label: {
    default: 'Amount',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '1000',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  showIfBlank: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  dataType: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', 'integer', 'decimal', 'currency'],
    delimiter: '\n  ',
  },
  formattingOptions: {
    default: '',
    editor: 'multilinetextbox',
    delimiter: '\n  ',
  },
};
const NumberFieldStory: Story = {
  title: 'Number',
  description: 'Numeric based fields',
  coreComponent: {
    html: `<tag-field{{...knobs}}>
</tag-field>`,
    knobs: NumberFieldStoryKnobs,
  },
  reactWrapper: { jsx: `<TagField{{...knobs}} />`, knobs: NumberFieldStoryKnobs },
};
const DateFieldStoryKnobs: Knobs = {
  label: {
    default: 'When',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  value: {
    default: '2019-10-05T14:48:00.000Z',
    editor: 'textbox',
    delimiter: '\n  ',
  },
  showIfBlank: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n  ',
  },
  dataType: {
    default: 'date',
    editor: 'dropdown',
    editorOptions: ['', 'date', 'datetime'],
    delimiter: '\n  ',
  },
  formattingOptions: {
    default: '',
    editor: 'multilinetextbox',
    delimiter: '\n  ',
  },
};
const DateFieldStory: Story = {
  title: 'Date',
  description: 'Date based fields',
  coreComponent: {
    html: `<tag-field{{...knobs}}>
</tag-field>`,
    knobs: DateFieldStoryKnobs,
  },
  reactWrapper: { jsx: `<TagField{{...knobs}} />`, knobs: DateFieldStoryKnobs },
};
const CustomStylesStory: Story = {
  title: 'Custom styles',
  description: 'A field with custom styles',
  coreComponent: {
    html: `<tag-field
  label='Name:'
  value='Rodney Peters'
  container-style='{"padding": "5px 10px"}'
  label-style='{"font-size": "16px", "width": "60px"}'
  value-style='{"font-size": "16px", "font-weight": "800"}'>
</tag-field>`,
  },
  reactWrapper: {
    jsx: `<TagField
  label='Name:'
  value='Rodney Peters'
  containerStyle={{padding: "5px 10px"}}
  labelStyle={{fontSize: "16px", "width": "60px"}}
  valueStyle={{fontSize: "16px", "fontWeight": "800"}}
/>`,
  },
};

export const TagFieldDocs: Component = {
  type: 'component',
  name: 'field',
  description: 'Renders a label and field value',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'The name of the field',
      type: 'string',
    },
    {
      name: 'label',
      description: 'The field label',
      type: 'string',
    },
    {
      name: 'dataType',
      default: 'string',
      description: 'The type of the field that is used for value formatting',
      type:
        'string | integer | decimal | currency | date | datetime | boolean | image | email | phonenumber',
    },
    {
      name: 'formattingOptions',
      description:
        'Additional formatting options for numbers. This maps directly to the options parameter in Intl.NumberFormat see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat',
      type: 'string',
    },
    {
      name: 'containerStyle',
      description: 'The container class name. Any utility class can be used',
      type: 'string',
    },
    {
      name: 'labelStyle',
      description: 'The label class name. Any utility class can be used',
      type: 'string',
    },
    {
      name: 'valueStyle',
      description: 'The value class name. Any utility class can be used',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The field value',
      type: 'any',
    },
    {
      name: 'showIfBlank',
      description:
        'Whether to show the field even if the value is undefined, null or an empty string',
      type: 'boolean',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [TextFieldStory, NumberFieldStory, DateFieldStory, CustomStylesStory],
};
